<template>
    <div>
      <LMap
        class="map"
        :center="position"
        :zoom="2"
        :scrollWheelZoom="false"
        style="height: 500px; width: 100%"
      >
        <LTileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <MarkersPage :places="offices" :markerIcon="customIcon" />
      </LMap>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { LMap, LTileLayer } from '@vue-leaflet/vue-leaflet'
  import MarkersPage from '@/components/MarkersPage.vue'
  import offices from '@/data/offices.json'
  import L from 'leaflet'
  
  
  const position = ref([38.763382853415536, 35.48314308291784])
  
  
  const customIcon = new L.Icon({
    iconUrl: require('@/data/icon.svg'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    shadowSize: [41, 41]
  })
  </script>
  
  <style scoped>
  .map {
  height: 97vh;
  width: 84vw;
  border-radius: 15px;
}
  </style>
